import type { Activity, ActivityType } from '@movmania/core'
import { estimateKcal } from '@movmania/core'

/**
 * Historique de démonstration : ~10 semaines de pratique irrégulière mais
 * crédible, avec un creux (pour voir le joker et la cassure de série) puis une
 * reprise. Sert aux démos cofondateur / entreprise — pas au premier lancement.
 */
export function buildDemoHistory(now = new Date()): Activity[] {
  const activities: Activity[] = []
  let counter = 0

  // [séances par semaine, durée moyenne] pour les 10 dernières semaines
  const plan: Array<[number, number]> = [
    [1, 30], // S-9 : démarrage timide
    [2, 40],
    [3, 45], // la série se lance
    [3, 50],
    [0, 0], // S-5 : semaine ratée -> joker
    [3, 45],
    [2, 35],
    [0, 0], // S-2 : deuxième creux
    [3, 55], // reprise
    [2, 45], // semaine en cours
  ]

  const types: ActivityType[] = ['walk', 'run', 'bike', 'yoga', 'strength', 'swim']

  plan.forEach(([sessions, duration], index) => {
    const weeksAgo = plan.length - 1 - index
    for (let s = 0; s < sessions; s++) {
      const dayOffset = weeksAgo * 7 - s * 2
      if (dayOffset < 0) continue
      const startedAt = new Date(now)
      startedAt.setDate(startedAt.getDate() - dayOffset)
      startedAt.setHours(18, 30, 0, 0)

      const type = types[(index + s) % types.length] as ActivityType
      const durationMin = duration + ((s * 7) % 15) - 5
      const activity: Activity = {
        id: `demo-${++counter}`,
        type,
        durationMin,
        startedAt: startedAt.toISOString(),
        source: 'manual',
      }
      activity.kcal = estimateKcal(activity)
      activities.push(activity)
    }
  })

  return activities.sort((a, b) => (a.startedAt < b.startedAt ? 1 : -1))
}
